<section style="margin-top: 20px;">
    <div class="row justify-content-center main-card m-0">
        <div class="col-6 mt-4 mb-4 content-sec">
            <div *ngIf="signInSec == true">
                <h2 class="text-center fw6">Sign in to Sierra Circuits</h2>
            </div>
            <div *ngIf="signUpSec == true">
                <h2 class="text-center fw6">Sign up</h2>
                <p class="text-center"><b>It is quick and easy</b></p>
            </div>
            <div *ngIf="forgotPwdSec == true">
                <h2 class="text-center fw6">Forgot your password?</h2>
                <p class="text-center"><b>Reset password</b></p>
            </div>
            <div *ngIf="updatePwdSce == true">
                <h2 class="text-center fw6">Update password</h2>
            </div>
            <div *ngIf="verificationForm == true" class="text-center">
              <img  src="/assets/img/verification.png" alt="shield" width="80" style="margin:0 10px;">
              <h2 class="text-center fw6">Enter verification code</h2>
              <div class="ion-text-center" style="margin-bottom:15px;">To ensure security, we have sent a  verification code to your registered email ID <br />Enter code below to login. The code is valid for 10 minutes.</div>
              <div class="ion-text-center">
                <div class="success-message" *ngIf="resendCodeSuccess == true">Code is generated successfully and sent to your registered email ID</div>
                <div class="error-message" *ngIf="otpNotVerify == true">Verification Code sent for the last login is still active, please enter that code or click on 'Resend Verification Code'.</div>
              </div>
              <div class="ion-text-center">
                <div class="verify-err-msg" *ngIf="verificationFailed == true">Invalid code entered, please try again.</div>
              </div>

            </div>
            <section class="mt-4" id="sign-in-sec" *ngIf="signInSec == true">
                <form [formGroup]="signInForm">
                  <div class="remaining-txt" *ngIf="unauthorizedUser == true">
                    <strong>Email address or password incorrect.</strong>
                  </div>
                  <div class="remaining-txt text-center mb-3" *ngIf="invalidAuthorizetion == true">
                    Invalid Email ID/ Password entered, please try again<br/>
                    <strong>Remaining login attempts: {{remainingAttempts}}</strong>
                  </div>
                <div class="text-left">
                    <label for="sign_in_mail" class="">Email<span class="require-sym">&lowast;</span></label>
                    <input type="text" class="form-control" id="sign_in_mail" placeholder="name@example.com" name="login_email_address" formControlName="signInEmail"  required maxlength="100">
                </div>
                <div class="validation-errors mb-2">
                    <ng-container *ngFor="let validation of signin_validation_messages.signInEmail">
                      <div class="error-message" *ngIf="signInForm.get('signInEmail')?.hasError(validation.type) && (signInForm.get('signInEmail')?.dirty || signInForm.get('signInEmail')?.touched)">
                        {{ validation.message }}
                      </div>
                    </ng-container>
                  </div>
                <div class="text-left">
                    <label for="sign_in_pwd" class="">Password<span class="require-sym">&lowast;</span></label>
                    <input type="password" class="form-control" id="sign_in_pwd" placeholder="Enter a password (5-50 charectors allowed)" formControlName="signInPWD"  required maxlength="100">
                </div>
                <div class="validation-errors">
                    <ng-container *ngFor="let validation of signin_validation_messages.signInPWD">
                      <div class="error-message" *ngIf="signInForm.get('signInPWD')?.hasError(validation.type) && (signInForm.get('signInPWD')?.dirty || signInForm.get('signInPWD')?.touched)">
                        {{ validation.message }}
                      </div>
                    </ng-container>
                  </div>
                <div>
                    <div class="col-12 text-right" style="text-align: right;"><p class="forgot-txt" (click)="gotoForgotPwd()">Forgot password</p></div>
                    <div class="d-grid gap-2 mt-4">
                        <button type="button" class="btn btn-warning" [disabled]="!signInForm.valid" (click)="signIn()"><b>Sign in</b></button>
                        <button type="button" class="btn btn-warning"(click)="gotoSignup()"><b>Not a member? Create an account</b></button>
                    </div>
                </div>
                </form>
            </section>

            <section class="mt-4" id="sign-up-sec" *ngIf="signUpSec == true">
                <form [formGroup]="signUpForm">
                <div class="text-left">
                    <label for="sign_up_mail" class="">Email<span class="require-sym">&lowast;</span></label>
                    <input type="text" class="form-control" id="sign_up_mail" placeholder="name@example.com" formControlName="signUpEmail"  required>
                </div>
                <div class="validation-errors mb-2">
                    <ng-container *ngFor="let validation of signup_validation_messages.signUpEmail">
                      <div class="error-message" *ngIf="signUpForm.get('signUpEmail')?.hasError(validation.type) && (signUpForm.get('signUpEmail')?.dirty || signUpForm.get('signUpEmail')?.touched)">
                        {{ validation.message }}
                      </div>
                    </ng-container>
                </div>
                <div class="text-left mt-2">
                    <label for="sign_up_pwd" class="">Password<span class="require-sym">&lowast;</span></label>
                    <input type="password" class="form-control" id="sign_up_pwd" placeholder="Enter a password (5-50 charectors allowed)" formControlName="signUpPwd"  required>
                </div>
                <div class="validation-errors mb-2">
                    <ng-container *ngFor="let validation of signup_validation_messages.signUpPwd">
                      <div class="error-message" *ngIf="signUpForm.get('signUpPwd')?.hasError(validation.type) && (signUpForm.get('signUpPwd')?.dirty || signUpForm.get('signUpPwd')?.touched)">
                        {{ validation.message }}
                      </div>
                    </ng-container>
                </div>
                <div class="text-left mt-2">
                    <label for="first_name" class="">First name<span class="require-sym">&lowast;</span></label>
                    <input type="text" class="form-control" id="first_name" placeholder="Enter your first name" formControlName="signUpFirstName"  required maxlength="100">
                </div>
                <div class="validation-errors mb-2">
                    <ng-container *ngFor="let validation of signup_validation_messages.signUpFirstName">
                      <div class="error-message" *ngIf="signUpForm.get('signUpFirstName')?.hasError(validation.type) && (signUpForm.get('signUpFirstName')?.dirty || signUpForm.get('signUpFirstName')?.touched)">
                        {{ validation.message }}
                      </div>
                    </ng-container>
                </div>
                <div class="text-left mt-2">
                    <label for="last_name" class="">Last name<span class="require-sym">&lowast;</span></label>
                    <input type="text" class="form-control" id="last_name" placeholder="Enter your last name" formControlName="signUpLastName"  required maxlength="100">
                </div>
                <div class="validation-errors mb-2">
                    <ng-container *ngFor="let validation of signup_validation_messages.signUpLastName">
                      <div class="error-message" *ngIf="signUpForm.get('signUpLastName')?.hasError(validation.type) && (signUpForm.get('signUpLastName')?.dirty || signUpForm.get('signUpLastName')?.touched)">
                        {{ validation.message }}
                      </div>
                    </ng-container>
                </div>
                <!-- <div class="text-left mt-2">
                    <label for="sign_up_mail" class="">Email<span class="require-sym">&lowast;</span></label>
                    <input type="text" class="form-control" id="sign_up_mail" placeholder="name@example.com" formControlName="signUpEmail"  required maxlength="100">
                </div> -->
                <div class="text-left mt-2">
                    <label for="company_name" class="">Company name<span class="require-sym">&lowast;</span></label>
                    <input type="text" class="form-control" id="company_name" placeholder="Enter N/A if not applicable" formControlName="signUpCompanyName"  required maxlength="100">
                </div>
                <div class="validation-errors mb-2">
                    <ng-container *ngFor="let validation of signup_validation_messages.signUpCompanyName">
                      <div class="error-message" *ngIf="signUpForm.get('signUpCompanyName')?.hasError(validation.type) && (signUpForm.get('signUpCompanyName')?.dirty || signUpForm.get('signUpCompanyName')?.touched)">
                        {{ validation.message }}
                      </div>
                    </ng-container>
                </div>
                <div class="text-left mt-2">
                    <label for="phone_number" class="">Phone number<span class="require-sym">&lowast;</span></label>
                    <input type="text" class="form-control" id="phone_number" placeholder="(212) 8798-8978" pattern="[0-9]*" formControlName="signUpPhoneNum"  required maxlength="100">
                </div>
                <div class="validation-errors mb-2">
                    <ng-container *ngFor="let validation of signup_validation_messages.signUpPhoneNum">
                      <div class="error-message" *ngIf="signUpForm.get('signUpPhoneNum')?.hasError(validation.type) && (signUpForm.get('signUpPhoneNum')?.dirty || signUpForm.get('signUpPhoneNum')?.touched)">
                        {{ validation.message }}
                      </div>
                    </ng-container>
                </div>
                <div>
                    <div class="col-12 text-center mt-2">By registering you agree the <a href="#">Terms & Conditions</a></div>
                    <div class="d-grid gap-2 mt-4">
                        <button type="button" class="btn btn-warning" [disabled]="!signUpForm.valid" (click)="signUp()"><b>Create your account</b></button>
                        <button type="button" class="btn btn-warning"(click)="gotoSignIn()"><b>Cancel</b></button>
                    </div>
                </div>
                </form>
            </section>

            <section class="mt-4" id="forgot-pwd" *ngIf="forgotPwdSec == true">
                <form [formGroup]="forgotPwdForm">
                <div class="text-left">
                    <label for="forgot_pwd_mail" class="">Email<span class="require-sym">&lowast;</span></label>
                    <input type="text" class="form-control" id="forgot_pwd_mail" placeholder="name@example.com" formControlName="forgotPwdEmail"  required maxlength="100">
                </div>
                <div class="validation-errors mb-2">
                    <ng-container *ngFor="let validation of forgot_validation_messages.forgotPwdEmail">
                      <div class="error-message" *ngIf="forgotPwdForm.get('forgotPwdEmail')?.hasError(validation.type) && (forgotPwdForm.get('forgotPwdEmail')?.dirty || forgotPwdForm.get('forgotPwdEmail')?.touched)">
                        {{ validation.message }}
                      </div>
                    </ng-container>
                  </div>
                <div>
                    <div class="d-grid gap-2 mt-4">
                        <button type="button" class="btn btn-warning" [disabled]="!forgotPwdForm.valid" (click)="forgotPwd()"><b>Continue</b></button>
                        <button type="button" class="btn btn-warning"(click)="gotoSignIn()"><b>Cancel</b></button>
                      </div>
                </div>
                </form>
            </section>

            <section class="mt-4" id="update_pwd_sec" *ngIf="updatePwdSce == true">
                <form [formGroup]="updatePwdForm">
                <div class="text-left">
                    <label for="update_pwd" class="">New password<span class="require-sym">&lowast;</span></label>
                    <input type="password" class="form-control" id="update_pwd" placeholder="Enter new password" formControlName="newPwd"  required maxlength="100">
                </div>
                <div class="validation-errors mb-2">
                    <ng-container *ngFor="let validation of update_password_validation_messages.newPwd">
                      <div class="error-message" *ngIf="updatePwdForm.get('newPwd')?.hasError(validation.type) && (updatePwdForm.get('newPwd')?.dirty || updatePwdForm.get('newPwd')?.touched)">
                        {{ validation.message }}
                      </div>
                    </ng-container>
                </div>
                <div class="text-left">
                    <label for="update_confirm_pwd" class="">Confirm new password<span class="require-sym">&lowast;</span></label>
                    <input type="password" class="form-control" id="update_confirm_pwd" placeholder="Confirm password" formControlName="confirmNewPwd"  required maxlength="100">
                </div>
                <div class="validation-errors mb-2">
                    <ng-container *ngFor="let validation of update_password_validation_messages.confirmNewPwd">
                      <div class="error-message" *ngIf="updatePwdForm.get('confirmNewPwd')?.hasError(validation.type) && (updatePwdForm.get('confirmNewPwd')?.dirty || updatePwdForm.get('confirmNewPwd')?.touched)">
                        {{ validation.message }}
                      </div>
                    </ng-container>
                </div>
                <div>
                    <div class="d-grid gap-2 mt-4">
                        <button type="button" class="btn btn-warning" [disabled]="!updatePwdForm.valid" (click)="updatePassword()"><b>Update passowrd</b></button>
                        <button type="button" class="btn btn-warning"(click)="gotoSignIn()"><b>Cancel</b></button>
                    </div>
                </div>
                </form>
            </section>

            <!-- 2FA -->
            <section class="mt-4" id="2FA-sec" *ngIf="verificationForm == true">
              <form [formGroup]="verificationFormGroup" class="text-center">
                <div>
                  <input type="text" class="verify-input" #otp1 id="otp1" required maxlength="1" tabindex="1" formControlName="vCode1" (keyup)="otpController($event,'',otp1,otp2)">
                  <input type="text" class="verify-input" #otp2 id="otp2" required maxlength="1" tabindex="2" formControlName="vCode2" (keyup)="otpController($event,otp1,otp2,otp3)">
                  <input type="text" class="verify-input" #otp3 id="otp3" required maxlength="1" tabindex="3" formControlName="vCode3" (keyup)="otpController($event,otp2,otp3,otp4)">
                  <span class="v-hyphen">-</span>
                  <input type="text" class="verify-input" #otp4 id="otp4" required maxlength="1" tabindex="4" formControlName="vCode4" (keyup)="otpController($event,otp3,otp4,otp5)">
                  <input type="text" class="verify-input" #otp5 id="otp5" required maxlength="1" tabindex="5" formControlName="vCode5" (keyup)="otpController($event,otp4,otp5,otp6)">
                  <input type="text" class="verify-input" #otp6 id="otp6" required maxlength="1" tabindex="6" formControlName="vCode6" (keyup)="otpController($event,otp5,otp6,'')">
                </div>
                <div class="row justify-content-center">
                  <div class="col-6 d-grid gap-2 mt-4">
                      <button type="button" class="btn btn-warning" [disabled]="!verificationFormGroup.valid" expand="block" (click)="verifyOtp()"><b>Verify</b></button>
                  </div>
                  <div class="col-12 d-grid gap-2 mt-3">
                    <p>Haven't recieved it? <a class="resend-link" style="cursor: pointer;" (click)="resendNewCode()" >Resend verification code</a></p>
                  </div>
                </div>
              </form>
            </section>

            <!--account locked-->
            <section class="mt-4" id="2FA-sec" *ngIf="accountLocked == true">
              <div class="row justify-content-center">
                <div class="col-12 d-grid gap-2 mt-4 text-center TFA_bg-red-section">
                  <p>Your account is temporarily locked for a duration of <b>2 hours</b> as a result of repeated unsuccessful login attempts.</p>
                  <p>To unlock your account before the 2-hour period, please get in touch with <b>Sierra Customer Support</b>.</p>
                  <div style="font-weight: bold;line-height: 1;">Gyanendra Behera</div>
                  <div style="font-weight: bold;line-height: 1;">Email: <a  style="color: #cf102d;text-decoration: none;" href ="mailto:ssdc_gyanendrab@protoexpress.com"> ssdc_gyanendrab&#64;protoexpress.com</a></div>
                  <div style="font-weight: bold;line-height: 1;">Call: <a style="color: #cf102d;text-decoration: none;" href="tel:+1 408 539 0778"> +1 (408) 539 0778</a></div>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-4 d-grid gap-2 mt-4">
                    <button type="button" class="btn btn-warning" (click)="closeAccountLockScreen()"><b>Close</b></button>
                </div>
              </div>
            </section>
        </div>
    </div>
</section>
